import { render, staticRenderFns } from "./org-contacts.vue?vue&type=template&id=05c39847&scoped=true&"
import script from "./org-contacts.vue?vue&type=script&lang=js&"
export * from "./org-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c39847",
  null
  
)

export default component.exports